import React, { type ReactNode, type FC } from 'react';
import cx from 'classnames';
import { Card, type CardProps } from 'antd';

import { type WithOptionalDataTest } from 'types';

import styles from './section.module.scss';

export namespace Section {
  export type Props = {
    full?: boolean;
    className?: string;
    children?: ReactNode;
    inline?: boolean;
    noPadding?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props & CardProps> = (props) => {
    const { className, children, dataTestId, full, inline, noPadding, ...antProps } = props;

    return (
      <Card
        {...antProps}
        data-testid={dataTestId}
        className={cx(
          styles.section,
          inline && styles.section_inline,
          noPadding && styles.section_noPadding,
          className,
        )}
      >
        <div className={cx(styles.section__content, full && styles.section__content_full)}>
          {children}
        </div>
      </Card>
    );
  };
}
